import React from 'react';
import { Link } from "react-router-dom";
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';


const ForgotPassword = () => {
    return (
        <>
            <SEO title="" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" style={{backgroundImage:"url('/images/bg/bg-login-2.png')",backgroundSize:"400px",backgroundRepeat:"no-repeat",backgroundPosition:"0%"}} data-black-overlay="1" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3">
                            </div>
                            <div className='col-lg-4 bg-forget'>
                                <div className='login-section'>
                                    <h1 className="login-title mt-5">Modify your password</h1>
                                    <p>Forgot your password? Enter the email address that you usually use to connect to N01Zet.</p>
                                    <form className="contact-form-2" action="" >
                                        <div className="form-group">
                                            <label>Email</label>
                                            <input type="email" name="email" placeholder="Your Email Address" required />
                                        </div>
                                        <div className="form-group">
                                            <button className="btn-default btn-small" style={{width:"100%"}}>Change my password</button>
                                        </div> 
                                        {/* <div className="form-group">
                                            {result ? <Result /> : null}
                                        </div>  */}
                                    </form>
                                    <div className='text-center login-text'>
                                        <p>You do not have an account ? <Link to="/register" className='login-text' style={{fontWeight:'bold'}}>Register</Link></p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-3 text-center forget-side'>
                                <img src="/images/bg/forgetlogo.png" alt='leaf' style={{width:'150px',paddingTop:'60px'}} />
                            </div>
                            <div className='col-lg-3 text-center'>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}
              
                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default ForgotPassword
